import { render, staticRenderFns } from "./ProExpansionPanel.vue?vue&type=template&id=6a4fdf14&scoped=true"
import script from "./ProExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ProExpansionPanel.vue?vue&type=script&lang=ts"
import style0 from "./ProExpansionPanel.vue?vue&type=style&index=0&id=6a4fdf14&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fdf14",
  null
  
)

export default component.exports